module.exports = __webpack_public_path__ + "media/img/illustrations/icons/action-undo-signoff-dd1aba7b88b425314482e07ff70277ea.svg";